// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateSelectedValue = (state, action) => action.selectedValue;

export default (state = getDefaultState().selectedValue, action) => {

    const actionTypes = {
        [actions.UPDATE_REIMBURSEMENT_SUMMARY_SELECTED_VALUE]: updateSelectedValue
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/reducers/selected-value.js